export default __webpack_public_path__ + "static/media/invite_color.19045785.svg";